<div class="">

    <!-- API - Cafe Name -->
    <div>
        <div *ngFor="let cafemenunamedata of cafemenunames; let i = index;">
            <div *ngIf="i==0 && cafemenunamedata.slnName!='' && cafemenunamedata.ltyname=='Cafe'">
                <!-- display the cafe name if the ship has a cafe & the cafe field name isn't empty -->
                <div class="sectionlabel">{{cafemenunamedata.slnName}}&nbsp;Options</div>
                <!-- cafe name = Lookout Cafe -->
            </div>
        </div>
    </div>


    <div class="twentypxtop"></div>



    <!-- 2 APIs - cafe menu & cafe menu times -->
    <div class="allFAQS">
        <div class="">
            <div *ngFor="let cafemenudata of cafemenus; let i = index;">
                <div>

                    <span class="mealtype" *ngIf="i==0 && cafemenudata.mttName!=''">
                        <!-- display the meal type (breakfast) as long as the field isn't empty -->
                        <span class="mealtype"> {{cafemenudata.mttName}}:
                            <span class="cafemealtime" *ngFor="let cafemenutimedata of cafemenutimes; let j = index;">
                                <span class="cafemealtime"
                                    *ngIf='cafemenudata.mttName=="Breakfast" && cafemenutimedata.aiiActivityName=="Early Riser&apos;s Breakfast"'>
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is breakfast and early riser's breakfast show the 6:30am-10am time -->
                                </span>
                                <span class="cafemealtime"
                                    *ngIf="cafemenudata.mttName=='Small Plates' && cafemenutimedata.aiiActivityName==cafemenunames[0].slnName">
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is small plates and back porch cafe show the 11am-5pm time -->
                                </span>
                                <span class="cafemealtime"
                                    *ngIf="cafemenudata.mttName=='Lunch' && cafemenutimedata.aiiActivityName==cafemenunames[0].slnName">
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is lunch and back porch cafe show the 11am-5pm time -->
                                </span>
                            </span>
                        </span>
                    </span>
                    <span>
                        <span class="mealtype"
                            *ngIf="i>0 && cafemenus[i].mttName!=cafemenus[i-1].mttName && cafemenudata.mttName!=''">
                            <!-- if the meal type (breakfast) is displayed once do not display it again -->

                            {{cafemenudata.mttName}}:

                            <span class="cafemealtime" *ngFor="let cafemenutimedata of cafemenutimes; let j = index;">
                                <span class="cafemealtime"
                                    *ngIf='cafemenudata.mttName=="Breakfast" && cafemenutimedata.aiiActivityName=="Early Riser&apos;s Breakfast"'>
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is breakfast and early riser's breakfast show the 6:30am-10am time -->
                                </span>
                                <span class="cafemealtime"
                                    *ngIf="cafemenudata.mttName=='Small Plates' && cafemenutimedata.aiiActivityName==cafemenunames[0].slnName">
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is small plates and back porch cafe show the 11am-5pm time -->
                                </span>
                                <span class="cafemealtime"
                                    *ngIf="cafemenudata.mttName=='Lunch' && cafemenutimedata.aiiActivityName==cafemenunames[0].slnName">
                                    {{cafemenutimedata.aiibegtime | timepipe}}-{{cafemenutimedata.aiiendtime |
                                    timepipe}}
                                    <!-- if it is lunch and back porch cafe show the 11am-5pm time -->
                                </span>
                            </span>
                        </span>

                    </span>


                </div>

                <div class="tenpxtop"></div>

                <div class="cafemealname"> {{cafemenudata.mitName}}</div>
                <div class="mealdesc" *ngIf="cafemenudata.mitGuestDescription!=undefined">
                    -{{cafemenudata.mitGuestDescription}}</div>
                <!-- display the dash (-) and menu item description if the content as long as the content isn't empty/undefined/null  -->
                <div class="tenpxtop"></div>


            </div>
        </div>

    </div>


    <div class="tenpxtop"></div>
    <div class="disclaimer">
        *Items marked with an asterisk may be served raw or undercooked. Consuming raw or undercooked meats, poultry,
        seafood,
        shellfish, or eggs may increase your risk of foodborne illness, especially if you have certain medical
        conditions.
        Please advise your server of any food allergies. Our food may have come in contact or contain peanuts, tree
        nuts, soy,
        milk, eggs, wheat, shellfish, sesame, or fish.
    </div>
    <div class="tenpxtop"></div>


</div>